import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BMEventsType } from '../types';
import { BaseMetric, MetricState } from './base-metric';
export var WebVitalsMetric = /*#__PURE__*/function (_BaseMetric) {
  _inherits(WebVitalsMetric, _BaseMetric);
  var _super = _createSuper(WebVitalsMetric);
  function WebVitalsMetric(_ref) {
    var _this;
    var key = _ref.key,
      route = _ref.route,
      startTime = _ref.startTime,
      stopTime = _ref.stopTime,
      pageVisibleState = _ref.pageVisibleState;
    _classCallCheck(this, WebVitalsMetric);
    _this = _super.call(this, {
      type: BMEventsType.WEB_VITALS,
      key: key
    });
    _this.route = route;
    _this.startTime = startTime;
    _this.stopTime = stopTime;
    _this.state = MetricState.FINISHED;
    _this.pageVisibleState = pageVisibleState;
    return _this;
  }
  return _createClass(WebVitalsMetric);
}(BaseMetric);